import { ref, nextTick } from 'vue';

const useAutoResize = () => {
  const textareaRef = ref(null);

  const autoResize = () => {
    nextTick(() => {
      if (textareaRef.value) {
        textareaRef.value.style.height = 'auto';
        textareaRef.value.style.height = textareaRef.value.scrollHeight + 'px';
      }
    });
  };

  return {
    textareaRef,
    autoResize,
  };
};

export default useAutoResize;
